import React, {Component} from "react";
import {attachKitByComponents} from "../../redux/actions/kit";
import {Button as RNButton, Image, Platform, ScrollView, StyleSheet, Text, View,} from "react-native";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import MenuButton from "../../components/MenuButton";
import WebHeading from "../../components/WebHeading";
import goTo, {goBack} from "../../utils/goTo";
import {errorColors, RepositColours, RepositStyles} from "../../utils/styles";
import Icon from "react-native-vector-icons/FontAwesome";

import Kit0G0S from "./icons/kit/0l0s.png";
import Kit0G1S from "./icons/kit/0l1s.png";
import Kit0G2S from "./icons/kit/0l2s.png";
import Kit0G3S from "./icons/kit/0l3s.png";
import Kit1G0S from "./icons/kit/1l0s.png";
import Kit1G1S from "./icons/kit/1l1s.png";
import Kit1G2S from "./icons/kit/1l2s.png";
import Kit1G3S from "./icons/kit/1l3s.png";
import Kit2G0S from "./icons/kit/2l0s.png";
import Kit2G1S from "./icons/kit/2l1s.png";
import Kit2G2S from "./icons/kit/2l2s.png";
import Kit2G3S from "./icons/kit/2l3s.png";
import Kit3G0S from "./icons/kit/3l0s.png";
import Kit3G1S from "./icons/kit/3l1s.png";
import Kit3G2S from "./icons/kit/3l2s.png";
import Kit3G3S from "./icons/kit/3l3s.png";
import {serializeDesign} from "./KitConstants";
import {insertSerialNum} from "../../redux/actions/box";
import storage from "../../utils/storage";

const styles = StyleSheet.create({
  listItem: {
    maxWidth: 400,
    minWidth: 350,
    height: 110,
    flexDirection: "row",
    alignItems: "center",
  },
  textInputTitle: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
  },
  textInput: {
    fontSize: 16,
    height: Platform.OS === "android" ? 40 : 25,
    textAlign: "center",
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 300,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    borderBottomColor: "#D2D2D2",
  },
  bodyTextContainer: {
    flex: 1,
    alignItems: "center",
  },
  wrapper: {
    backgroundColor: "white",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
  },
  heading: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#DFE6F5",
    marginHorizontal: 20,
  },
  headingText: {
    color: RepositColours.lightGrey,
    lineHeight: 22,
    fontWeight: "600",
  },
  text: {
    lineHeight: 22,
    fontWeight: "600",
  },
  bodyText: {
    marginHorizontal: 32,
  },
  stepBox: {
    flexDirection: "row",
    marginBottom: 50,
    marginHorizontal: 50,
  },
  addressBox: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: StyleSheet.hairlineWidth,
    marginHorizontal: 20,
    marginVertical: 10,
  },
});

const DIAGRAMS = [
  [Kit0G0S, Kit0G1S, Kit0G2S, Kit0G3S],
  [Kit1G0S, Kit1G1S, Kit1G2S, Kit1G3S],
  [Kit2G0S, Kit2G1S, Kit2G2S, Kit2G3S],
  [Kit3G0S, Kit3G1S, Kit3G2S, Kit3G3S],
];

const BoxIllustration = ({ gridMeters, solarMeters }) => (
  <Image
    source={DIAGRAMS[gridMeters.length][solarMeters.length]}
    style={{ width: "100%", height: 142, resizeMode: "contain" }}
    alt="Reposit Kit"
  />
);

const mapStateToProps = (state) => ({
  edmiSerial: state.edmi.serial,
  kit: state.kit,
  hardware: state.designer.kit.hardware,
  warnings: state.designer.kit.warnings,
  design: state.designer.kit.design,
  serial: state.box.serialNumber,
  customer: state.customer.selectedSite,
  loading: state.kit.loading,
});

const mapDispatchToProps = (dispatch) => {
  return {
    connectionActions: bindActionCreators({ attachKitByComponents }, dispatch),
    kitActions: bindActionCreators({ insertSerialNum }, dispatch),
  };
};

class KitSummary extends Component {
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "Confirm Kit",
  };

  componentWillReceiveProps = (nextProps) => {
    if (
      this.props.kit.registrationStatus === "ATTACHING" &&
      nextProps.kit.registrationStatus === "SUCCESS"
    ) {
      goTo(nextProps.navigation, "ConnectionType");
    }
  };

  handleNext = () => {
    const { design, customer, serial, edmiSerial } = this.props;
    // TODO wait for attachment before proceeding?
    if (!serial) {
      storage
        .load({ key: "serialNum" })
        .then((ret) => {
          this.props.kitActions.insertSerialNum(ret);
          this.props.connectionActions.attachKitByComponents(
            serializeDesign(design, edmiSerial),
            customer,
            ret
          );
        })
        .catch((err) => {
          console.log(err);
          this.props.connectionActions.attachKitByComponents(
            serializeDesign(design, edmiSerial),
            customer,
            serial
          );
        });
    } else {
      this.props.connectionActions.attachKitByComponents(
        serializeDesign(design, edmiSerial),
        customer,
        serial
      );
    }
  };

  getWarningsText = (warnings) => {
    let warningTextList = [];
    for (let warning of warnings) {
      warningTextList.push(
        <Text style={{ color: errorColors.orange }}>
          <Icon name="exclamation-circle" /> {warning}
        </Text>
      );
    }
    return warningTextList;
  };

  getGridPhaseText = () => {
    const phaseNetwork = " phase network";
    switch (this.props.design.gridPhases.value) {
      case 1:
        return "Single" + phaseNetwork;
      case 2:
        return "Two" + phaseNetwork;
      case 3:
        return "Three" + phaseNetwork;
      default:
        return null;
    }
  };

  getPoles = () => {
    const { controller, gridMeters, solarMeters } = this.props.hardware;
    return (
      controller.poles +
      gridMeters
        .concat(solarMeters)
        .map((meter) => meter.poles)
        .reduce((acc, val) => acc + val, 0)
    );
  };

  render() {
    const hardware = this.props.hardware;

    if (Platform.OS === "web" && !this.props.design.gridPhases.value) {
      if (this.props.path === "/KitSummary") {
        goBack();
      }
      return null;
    }

    if (!hardware) {
      return <Text>Loading</Text>;
    } else {
      const { controller, gridMeters, solarMeters } = hardware;
      const meters = gridMeters.concat(solarMeters);
      return (
        <View style={styles.wrapper}>
          <WebHeading title="Confirm Kit" />
          <View style={{ flex: 1, alignItems: "center" }}>
            <View
              style={{ flex: 1, width: "100%", maxWidth: 800, maxHeight: 800 }}
            >
              <View style={{ flex: 2 }}>
                <View
                  style={{
                    flex: 0,
                    justifyContent: "center",
                    alignItems: "center",
                    margin: 22,
                  }}
                >
                  <BoxIllustration
                    gridMeters={gridMeters}
                    solarMeters={solarMeters}
                  />
                </View>
                <View style={{ ...styles.bodyText, flex: 1 }}>
                  <View style={{ flexDirection: "column" }}>
                    <Text style={styles.text}>{this.getGridPhaseText()}</Text>
                    <Text style={styles.text}>
                      {this.getPoles()} DIN rail poles required
                    </Text>
                  </View>
                  <ScrollView
                    style={{ marginTop: 12, minHeight: 220, maxHeight: 220 }}
                  >
                    <Text style={styles.headingText}>Reposit Kit</Text>
                    <Text style={styles.text}>{controller.description}</Text>
                    {meters.map((meter) => (
                      <Text style={styles.text} key={meter.description}>
                        {meter.description}
                      </Text>
                    ))}
                    {this.props.warnings.length > 0
                      ? this.getWarningsText(this.props.warnings)
                      : null}
                  </ScrollView>
                </View>
                <View
                  style={{
                    flexDirection: "column",
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <RNButton
                    title=" Next "
                    onPress={this.handleNext}
                    color={RepositColours.blue}
                  />
                  <Text style={RepositStyles.nextSub}>Internet Connection</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      );
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(KitSummary);



// WEBPACK FOOTER //
// ./src/containers/kit/KitSummary.js